import { CircularProgress, FormControl, SxProps, TextField, Theme } from '@mui/material';
import Box from '@mui/material/Box';
import React, { FC, useContext, useEffect, useState } from 'react';
import { useStyles } from '../../theme/styles.helpers';
import { PatientsStyles } from './Patients.styles';
import { useTranslation } from 'react-i18next';
import { useRedirectOnAuth } from '../../aws/AuthHooks';
import { AuthContext, AuthState } from '../../aws/AuthProvider';
import { ROUTE } from '../routes';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import CustomersList, { AppstleSubscription, ShopifyCustomerWithOrders } from '../../components/customers/Customers';
import OldSubscriptions from '../../components/customers/OldSubscriptions';
import AppstleSubscriptions from '../../components/customers/AppstleSubscriptions';
import { DataContext } from '../../aws/DataProvider';
import { getAllCustomersWithOrders, getAppstleSubscriptions } from '../../aws/RequestsApi';
import { Customers } from '@hellohair/types';

interface PatientsProps {
  /** styles */
  sx?: SxProps<Theme>;
}

const Patients: FC<PatientsProps> = () => {
  useRedirectOnAuth([AuthState.UNAUTHORIZED], ROUTE.LOGIN);
  const {
    customersState: [customers],
  } = useContext(DataContext);

  const styles = useStyles(PatientsStyles, {});
  const [shopifyCustomers, setShopifyCustomers] = useState<ShopifyCustomerWithOrders[]>([]);
  const [appstleSubscriptions, setAppstleSubscriptions] = useState<AppstleSubscription[]>([]);

  const { t } = useTranslation();
  const [selectedTab, setTab] = useState('one');
  const [search, setSearch] = useState<string>('');
  const { apiClient } = useContext(AuthContext);

  useEffect(() => {
    getAllCustomersWithOrders(apiClient, 'network-only').then((allCustomers) => {
      setShopifyCustomers(allCustomers);
    });
    getAppstleSubscriptions(apiClient, 'network-only').then((appsleSubs) => {
      setAppstleSubscriptions(appsleSubs);
    });
  }, []);

  const mappedShopifyCustomers = shopifyCustomers.map((customer) => ({
    customerId: customer.id,
    dateCreated: customer.createdAt,
    email: customer.email,
    gender: '',
    firstName: customer.firstName,
    lastName: customer.lastName,
    name: customer.firstName + ' ' + customer.lastName,
    phoneNumber: '',
    groups: [],
    isActive: true,
    shopifyOrders: customer.orders,
  })) as unknown as Customers.ShopCustomer[];

  return (
    <Box sx={styles.container}>
      <Box sx={styles.header}>
        <Box sx={{ width: '100%' }}>
          <Tabs
            value={selectedTab}
            onChange={(_event: React.SyntheticEvent, newValue: string) => {
              setTab(newValue);
              setSearch('');
            }}
          >
            <Tab value="one" label={t('Patients')} />
            <Tab
              value="two"
              label={'Shopify ' + t('Patients')}
              iconPosition={'end'}
              icon={
                shopifyCustomers.length === 0 ? (
                  <CircularProgress color={'secondary'} size={18} thickness={5} />
                ) : undefined
              }
              disabled={shopifyCustomers.length === 0}
            />
            <Tab value="three" label={t('Old subscriptions')} />
            <Tab
              value="four"
              label={'Appstle ' + t('Subscriptions')}
              iconPosition={'end'}
              icon={
                appstleSubscriptions.length === 0 ? (
                  <CircularProgress color={'secondary'} size={18} thickness={5} />
                ) : undefined
              }
              disabled={appstleSubscriptions.length === 0}
            />
          </Tabs>
        </Box>
        <Box display={'flex'} gap={2}>
          <FormControl sx={{ width: 300 }} variant="outlined">
            <TextField
              label="Suchen"
              variant="outlined"
              InputLabelProps={{ sx: { textIndent: '10px', fontSize: '18px' } }}
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </FormControl>
        </Box>
      </Box>

      {selectedTab === 'one' && <CustomersList search={search} customers={customers} fromShopify={false} />}
      {selectedTab === 'two' && (
        <CustomersList
          search={search}
          customers={mappedShopifyCustomers}
          fromShopify={true}
          appstleSubscriptions={appstleSubscriptions}
        />
      )}
      {selectedTab === 'three' && <OldSubscriptions search={search} />}
      {selectedTab === 'four' && <AppstleSubscriptions search={search} subscriptions={appstleSubscriptions} />}
    </Box>
  );
};

export default Patients;
